<template>
    <welcome-box>
        <password-reset />
    </welcome-box>
</template>

<script>
import WelcomeBox from '@/components/WelcomeBox.vue';
import PasswordReset from '@/components/PasswordReset/PasswordReset.vue';

export default {
    components: {
        WelcomeBox,
        PasswordReset,
    },
};
</script>
